import React from 'react'

import { MenuDivider } from '@blueprintjs/core'

import {
    NavButtonLink, NavRawButtonLinkMenuItem, NavButtonLinkMenuItem,
    Divider
} from '../../Elements'
import {
    CanViewRoles, CanViewAdminDashboard, CanExportData,
    CanSchedulePresite,
    CanViewGuniteSchedule,
    CanViewPlasterSchedule,
    CanViewWarrantyJobs
} from '../Auth'

import { useOnlineUtils } from '../../Hooks/offline'
import { primaryTheme, envShowCentralTexas, primaryLocation } from '../../utils/helpers'


const JobsMenuItems = () => {
    const { isOnline } = useOnlineUtils()
    return (
        <>
            <NavButtonLinkMenuItem icon='briefcase' text="Job Search" to='/job' />
            <NavButtonLinkMenuItem icon='calculator' text='Estimates' to='/estimate' />
            <NavButtonLinkMenuItem icon='people' className='navbar-button' to="/customer" text="Builders" />
            {isOnline &&
                <NavButtonLinkMenuItem icon='id-number' text='Employees' to='/employee' />
            }
            <NavButtonLinkMenuItem icon='home' text="Homeowners" to="/homeowner" />
        </>
    )
}

const JobsHamburgerItems = () => {
    const { isOnline } = useOnlineUtils()
    return (
        <>
            <div><NavButtonLink icon='briefcase' text="Job Search" to='/job' /></div>
            <div><NavButtonLink icon='calculator' text='Estimates' to='/estimate' /></div>
            <div><NavButtonLink icon='people' className='navbar-button' to="/customer" text="Builders" /></div>
            {isOnline &&
                <div><NavButtonLink icon='id-number' text='Employees' to='/employee' /></div>
            }
            <div><NavButtonLink icon='home' text="Homeowners" to="/homeowner" /></div>
        </>
    )
}

const InventoryMenuItems = () => (
    <>

        <NavButtonLinkMenuItem style={{ whiteSpace: 'nowrap' }} icon='numerical' text='Counts' to='/inventory-count' />
        {envShowCentralTexas &&
            <NavButtonLinkMenuItem text='Current Inventory - Austin' icon='clipboard' popoverProps={{ openOnTargetFocus: false }}>
                <NavButtonLinkMenuItem to='/reports/inventory/austin/1' text='Drains' icon='clipboard' />
                <NavButtonLinkMenuItem to='/reports/inventory/austin/2' text='Beadcrete' icon='clipboard' />
                <NavButtonLinkMenuItem to='/reports/inventory/austin/3' text='Pigment' icon='clipboard' />
                <NavButtonLinkMenuItem to='/reports/inventory/austin/4' text='PT-Warehouse' icon='clipboard' />
                <NavButtonLinkMenuItem to='/reports/inventory/austin/5' text='Rock' icon='clipboard' />
            </NavButtonLinkMenuItem>
        }
        <NavButtonLinkMenuItem text={envShowCentralTexas ? `Current Inventory - ${primaryLocation}` : `Current Inventory`} icon='clipboard' popoverProps={{ openOnTargetFocus: false }}>
            <NavButtonLinkMenuItem to={`/reports/inventory/${primaryLocation?.toLowerCase()}/1`} text='Drains' icon='clipboard' />
            <NavButtonLinkMenuItem to={`/reports/inventory/${primaryLocation?.toLowerCase()}/2`} text='Beadcrete' icon='clipboard' />
            <NavButtonLinkMenuItem to={`/reports/inventory/${primaryLocation?.toLowerCase()}/3`} text='Pigment' icon='clipboard' />
            <NavButtonLinkMenuItem to={`/reports/inventory/${primaryLocation?.toLowerCase()}/4`} text='PT-Warehouse' icon='clipboard' />
            <NavButtonLinkMenuItem to={`/reports/inventory/${primaryLocation?.toLowerCase()}/5`} text='Rock' icon='clipboard' />
        </NavButtonLinkMenuItem>


        <NavButtonLinkMenuItem icon='shopping-cart' text='Purchase Orders' to='/purchaseOrder' />
        <NavButtonLinkMenuItem style={{ whiteSpace: 'nowrap' }} icon='tint' text="Color Recipes" to="/color-recipe" />
        <NavButtonLinkMenuItem style={{ whiteSpace: 'nowrap' }} icon='truck' text="Relocation Orders" to='/inventoryRelocation' />
    </>
)

const InventoryHamburgerItems = () => {
    const showCity = (text) => envShowCentralTexas ? `${primaryLocation} - ${text}` : text

    return (
        <>
            <div><NavButtonLink icon='numerical' text='Counts' to='/inventory-count' /></div>
            <Divider />
            {envShowCentralTexas &&
                <>
                    <div><NavButtonLink icon='clipboard' text='Austin - Drains' to='/reports/inventory/austin/1' /></div>
                    <div><NavButtonLink icon='clipboard' text='Austin - Beadcrete' to='/reports/inventory/austin/2' /></div>
                    <div><NavButtonLink icon='clipboard' text='Austin - Pigment' to='/reports/inventory/austin/3' /></div>
                    <div><NavButtonLink icon='clipboard' text='Austin - PT-Warehouse' to='/reports/inventory/austin/4' /></div>
                    <div><NavButtonLink icon='clipboard' text='Austin - Rock' to='/reports/inventory/austin/5' /></div>
                    <Divider />
                </>
            }
            <div><NavButtonLink icon='clipboard' text={showCity('Drains')} to={`/reports/inventory/${primaryLocation?.toLowerCase()}/1`} /></div>
            <div><NavButtonLink icon='clipboard' text={showCity('Beadcrete')} to={`/reports/inventory/${primaryLocation?.toLowerCase()}/2`} /></div>
            <div><NavButtonLink icon='clipboard' text={showCity('Pigment')} to={`/reports/inventory/${primaryLocation?.toLowerCase()}/3`} /></div>
            <div><NavButtonLink icon='clipboard' text={showCity('PT Warehouse')} to={`/reports/inventory/${primaryLocation?.toLowerCase()}/4`} /></div>
            <div><NavButtonLink icon='clipboard' text={showCity('Rock')} to={`/reports/inventory/${primaryLocation?.toLowerCase()}/5`} /></div>
            <Divider />
            <div><NavButtonLink icon='shopping-cart' text='Purchase Orders' to='/purchaseOrder' /></div>
            <div><NavButtonLink icon='tint' text="Color Recipes" to="/color-recipe" /></div>
        </>
    )
}

const ReportsMenuItems = () => (
    <>
        <NavButtonLinkMenuItem text='Calendar - Gunite' to='/calendar/gunite' icon='calendar' />
        <NavButtonLinkMenuItem text='Calendar - Pebble' to='/calendar/pebble' icon='calendar' />
        <MenuDivider />
        <NavButtonLinkMenuItem text='Customer - Contact List' to='/reports/customer-contact-list/' icon='people' />
        <NavButtonLinkMenuItem text='Customer - Top 50 Contacts' to='/reports/top-contacts' icon='people' />
        <MenuDivider />
        <NavButtonLinkMenuItem text='Color Location' to='/reports/color-location' icon='send-to-map' />
        <NavButtonLinkMenuItem text='Coverage' to='/reports/coverage' icon='highlight' />
        <NavButtonLinkMenuItem text='Per Company Job Report' to='/reports/per-company-job' icon='full-stacked-chart' />
        <NavButtonLinkMenuItem text='Slurry Pickup' to='/reports/slurry-pickup' icon='tractor' />
        <NavButtonLinkMenuItem text='Warranty Aging' to='/reports/warranty-aging' icon='build' />
        <NavButtonLinkMenuItem text='Warranty Jobs Outstanding' to='/reports/warranty-jobs-outstanding' icon='th-list' />
        <MenuDivider />
        <NavRawButtonLinkMenuItem text='Year-Over-Year Gunite' to='/reports/year-over-year/gunite' icon='chart' target='_blank' />
        <NavRawButtonLinkMenuItem text='Year-Over-Year Pebble' to='/reports/year-over-year/pebble' icon='chart' target='_blank' />
        <NavRawButtonLinkMenuItem text='Year-Over-Year Pebble (Remodel)' to='/reports/year-over-year/remodels' icon='chart' target='_blank' />
    </>
)

const ReportsHamburgerItems = () => (
    <>
        <div><NavButtonLink text='Calendar - Gunite' to='/calendar/gunite' icon='calendar' /></div>
        <div><NavButtonLink text='Calendar - Pebble' to='/calendar/pebble' icon='calendar' /></div>
        <Divider />
        <div><NavButtonLink text='Customer List' to='/reports/customer-contact-list/' icon='people' /></div>
        <div><NavButtonLink text='Top 50 Customers' to='/reports/top-contacts' icon='people' /></div>
        <Divider />
        <div><NavButtonLink text='Color Location' to='/reports/color-location' icon='send-to-map' /></div>
        <div><NavButtonLink text='Coverage' to='/reports/coverage' icon='highlight' /></div>
        <div><NavButtonLink to='/reports/per-company-job' text='Per Company Job' icon='full-stacked-chart' /></div>
        <div><NavButtonLink to='/reports/slurry-pickup' text='Slurry Pickup' icon='tractor' /></div>
        <div><NavButtonLink to='/reports/warranty-aging' text='Warranty Aging Report' icon='build' /></div>
        <div><NavButtonLink to='/reports/warranty-jobs-outstanding' text='Warranty Jobs Outstanding' icon='th-list' /></div>
        <Divider />
        <div><NavButtonLink text='YoY Gunite' to='/reports/year-over-year/gunite' icon='chart' target='_blank' /></div>
        <div><NavButtonLink text='YoY Pebble' to='/reports/year-over-year/pebble' icon='chart' target='_blank' /></div>
        <div><NavButtonLink text='YoY Pebble (Remodel)' to='/reports/year-over-year/remodels' icon='chart' target='_blank' /></div>
    </>
)

const DigitalBoardMenuItems = () => (
    <>
        <CanViewGuniteSchedule>
            <NavButtonLinkMenuItem text='Gunite' icon='grid-view' popoverProps={{ openOnTargetFocus: false }}>
                <NavButtonLinkMenuItem to='/DigitalBoard/Gunite' text='Week View' icon='grid-view' />
                <NavButtonLinkMenuItem to='/DayView/Gunite' text='Day View' icon='symbol-square' />
            </NavButtonLinkMenuItem>
        </CanViewGuniteSchedule>

        <CanViewPlasterSchedule>
            <NavButtonLinkMenuItem text='Pebble' icon='new-grid-item' popoverProps={{ openOnTargetFocus: false }}>
                <NavButtonLinkMenuItem to='/PebbleWeeklyDigitalBoard' text='Week View' icon='new-grid-item' />
                <NavButtonLinkMenuItem to='/DayView/Pebble' text='Day View' icon='flash' />
            </NavButtonLinkMenuItem>
        </CanViewPlasterSchedule>

        <CanViewWarrantyJobs>
            <NavButtonLinkMenuItem text='Warranty' icon='vertical-distribution' popoverProps={{ openOnTargetFocus: false }}>
                <NavButtonLinkMenuItem to='/DigitalBoard/Warranty' text='Day View' icon='vertical-distribution' />
                <NavButtonLinkMenuItem to='/DigitalBoard/WarrantyMonth' text='Month View' icon='timeline-events' />
                <NavButtonLinkMenuItem to='/TeamSchedule' text='Team Schedule' icon='panel-table' />
            </NavButtonLinkMenuItem>
        </CanViewWarrantyJobs>

        <CanSchedulePresite>
            <Divider />
            <NavButtonLinkMenuItem to='/PresiteSchedule' text='Presite' icon='path-search' />
        </CanSchedulePresite>


        <Divider />
        <NavButtonLinkMenuItem to='/Schedule' text='My Schedule' icon='time' />
    </>
)

const DigitalBoardHamburgerItems = () => (
    <>
        <div><NavButtonLink to='/Schedule' text='My Schedule' icon='time' /></div>
        <CanViewWarrantyJobs>
            <div><NavButtonLink to='/TeamSchedule' text='Warranty - Team Schedule' icon='panel-table' /></div>
        </CanViewWarrantyJobs>
        <CanSchedulePresite>
            <div><NavButtonLink to='/PresiteSchedule' text='Presite' icon='path-search' /></div>
        </CanSchedulePresite>
    </>
)
//     <div><NavButtonLink to='/DigitalBoard/Gunite' text='Gunite' icon='grid-view' /></div>
//     <div><NavButtonLink to='/DayView/Gunite' text='Gunite -  Day View' icon='symbol-square' /></div>
//     <div><NavButtonLink to='/DigitalBoard/Pebble' text='Pebble' icon='new-grid-item' /></div>
//     <div><NavButtonLink to='/DayView/Pebble' text='Pebble - Day View' icon='flash' /></div>
//     <div><NavButtonLink to='/DigitalBoard/Warranty' text='Warranty - Day' icon='vertical-distribution' /></div>
//     <div><NavButtonLink to='/DigitalBoard/WarrantyMonth' text='Warranty - Month' icon='timeline-events' /></div>
//   </>
// )
// // Might add this back later, if these pages are made Mobile Friendly

const UtilityShortcutMenuItems = () => (
    <>
        <NavButtonLinkMenuItem text='Builder Setup' to='/customer/new' icon='people' />
        <NavButtonLinkMenuItem text='Employee Setup' to='/employee/new' icon='id-number' />
        <NavButtonLinkMenuItem text='User Setup' to='/user/new' icon='user' />
    </>
)

const UtilityShortcutHamburgerItems = () => (
    <>
        <div><NavButtonLink text='Builder Setup' to='/customer/new' icon='people' /></div>
        <div><NavButtonLink text='Employee Setup' to='/employee/new' icon='id-number' /></div>
        <div><NavButtonLink text='User Setup' to='/user/new' icon='user' /></div>
    </>
)

const AdminMenuItems = () => (
    <>
        <CanViewRoles>
            <NavButtonLinkMenuItem text='Role Permissions' to='/roles' icon='hat' />
        </CanViewRoles>
        <CanViewAdminDashboard>
            <NavButtonLinkMenuItem text='Administrator Dashboard' to='/admin' icon='crown' />
        </CanViewAdminDashboard>
        <CanExportData>
            <NavButtonLinkMenuItem text='Export' to='/admin/export' icon='export' />
        </CanExportData>
    </>
)

const AdminHamburgerItems = () => (
    <>
        <CanViewRoles>
            <div><NavButtonLink text='Role Permissions' to='/roles' icon='hat' /></div>
        </CanViewRoles>
        <CanViewAdminDashboard>
            <div><NavButtonLink text='Administrator Dashboard' to='/admin' icon='crown' /></div>
        </CanViewAdminDashboard>
        <CanExportData>
            <div><NavButtonLink text='Exports' to='/admin/export' icon='export' /></div>
        </CanExportData>

    </>
)

const navHeaderStyle = {
    fontFamily: 'Rockwell',
    paddingTop: 5,
    color: primaryTheme,
    fontSize: '1.2em'
}

export {
    JobsMenuItems, JobsHamburgerItems,
    InventoryMenuItems, InventoryHamburgerItems,
    ReportsMenuItems, ReportsHamburgerItems,
    DigitalBoardMenuItems, DigitalBoardHamburgerItems,
    UtilityShortcutMenuItems, UtilityShortcutHamburgerItems,
    AdminMenuItems, AdminHamburgerItems, navHeaderStyle
}
